import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Status da conta',
  since: 'desde {{date}}',
  loadError: 'Não foi possível carregar o histórico',
  retry: 'Tentar de novo',
  entries: {
    submitted: 'Enviada para análise',
    registered: 'Cadastrada e aprovada pela equipe Bodyprint',
    claimed: 'Conta assumida pelo responsável',
    approved: 'Aprovada pela equipe Bodyprint',
    rejected: 'Recusada pela equipe Bodyprint',
    suspended: 'Suspensa pela equipe Bodyprint',
    reactivated: 'Reativada pela equipe Bodyprint',
  },
} satisfies TranslationTree;
